import * as React from 'react'
import Client from '../../../client'
import { LoadableSelect } from '../../../components/Inputs'

export interface ListingStrategyPickerOption {
  label: string
  value: number
}

export interface ListingStrategyPickerProps {
  disabled?: boolean
  onChange: Function
  value?: number
  title?: string
}

const ListingStrategyPicker: React.FC<ListingStrategyPickerProps> = props => (
  <LoadableSelect
    load={Client.getListingStrategies}
    disabled={props.disabled}
    autoload
    process={d =>
      d.listingStrategies.map(l => ({
        label: l.name,
        value: l.id
      }))
    }
    onChange={(v: ListingStrategyPickerOption) => props.onChange(v)}
    {...props}
  />
)

export default ListingStrategyPicker
